import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 150px;
  flex: none;
  gap: 6px;
  justify-content: center;
  width: 60px;
`;

export const Scale = styled.div`
  background: linear-gradient(
    #e23122,
    #ec682c,
    #f09e38,
    #ffff54,
    #7efb55,
    #7afbc9,
    #6cdffb,
    #6297f8
  );
  width: 20px;
  height: 140px;
`;

export const Labels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 30px;
  height: 140px;
`;

export const Label = styled.div`
  ${({ theme }) => theme.font.t4};
`;
